import { render, staticRenderFns } from "./WhyPartner.vue?vue&type=template&id=1bffce88&scoped=true&"
import script from "./WhyPartner.vue?vue&type=script&lang=js&"
export * from "./WhyPartner.vue?vue&type=script&lang=js&"
import style0 from "./WhyPartner.vue?vue&type=style&index=0&id=1bffce88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bffce88",
  null
  
)

export default component.exports